module.exports = __webpack_public_path__ + "static/scale-model-of-lewisville-texas-15c8dc2f3bd0b759787e8bc9804663a7.png";